import { connect } from 'react-redux';

import { sendNotifyMe } from 'shared/store/notifyMe/action';
import { State } from 'store/types';
import View from './View';


const mapDispatchToProps = {
  sendNotifyMe,
};

const mapStateToProps = (state: State) => {
  const { auth } = state;

  return {
    userEmail: auth.user.email,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
